"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListEmptyRow = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const Table_1 = require("./Table");
const ListEmptyRow = ({ colSpan, filtered, title, hint, action }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Table_1.TableRow, { children: (0, jsx_runtime_1.jsxs)(Table_1.TableCell, { colSpan: colSpan, className: "py-10 text-center whitespace-normal", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium text-fg", children: filtered ? t('common.messages.noResults') : title }), (filtered || hint) && (0, jsx_runtime_1.jsx)("p", { className: "mt-1 text-[13px] text-fg-secondary", children: filtered ? t('common.filters.noResultsHint') : hint }), !filtered && action && (0, jsx_runtime_1.jsx)("div", { className: "mt-4 flex justify-center", children: action })] }) }));
};
exports.ListEmptyRow = ListEmptyRow;
exports.ListEmptyRow.displayName = 'ListEmptyRow';
